<input [id]="inputId" [attr.name]="name || null" type="text" [class]="inputClass" [placeholder]="placeholder"
  [attr.data-test]="inputTestId" [value]="value" [disabled]="disabled"
  [attr.autocomplete]="enabled ? 'off' : null"
  [attr.role]="enabled ? 'combobox' : null" [attr.aria-autocomplete]="enabled ? 'list' : null"
  [attr.aria-controls]="enabled ? listboxId : null" [attr.aria-expanded]="enabled ? open : null"
  [attr.aria-activedescendant]="enabled && open && active >= 0 ? optionId(active) : null"
  (input)="onInput($any($event.target).value)" (keydown)="onKeydown($event)" (keyup)="onKeyup($event)" (focus)="onFocus()" (blur)="onBlur()" />
@if (enabled) {
  <ul [id]="listboxId" role="listbox" [attr.aria-label]="listLabel" [attr.data-test]="listTestId"
    class="tw:absolute tw:left-0 tw:top-full tw:z-20 tw:mt-1 tw:min-w-80 tw:max-h-80 tw:overflow-auto tw:list-none tw:m-0 tw:p-0 tw:bg-white tw:border tw:border-gray-300 tw:rounded tw:shadow-lg"
    [hidden]="!open">
    @if (open) {
      @for (item of suggestions; track $index; let i = $index) {
        <li role="option" [id]="optionId(i)" [attr.aria-selected]="i === active" [attr.data-test]="optionTestId"
          class="tw:px-3 tw:py-2 tw:cursor-pointer tw:border-b tw:border-gray-100 tw:last:border-b-0"
          [ngClass]="i === active ? 'tw:bg-blue-50' : 'tw:hover:bg-gray-50'"
          (mousedown)="$event.preventDefault()" (click)="choose(item)">
          @if (optionTemplate) {
            <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: item, index: i }"></ng-container>
          } @else {
            <span class="tw:block tw:font-bold">{{displayWith(item)}}</span>
            @if (secondary(item)) {
              <span class="tw:block tw:text-xs tw:text-gray-600">{{secondary(item)}}</span>
            }
          }
        </li>
      }
    }
  </ul>
}
